import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  max-height: 260px;

  &.spawn {
    max-height: 200px;
  }
`;

export const Flex = styled.div`
  flex: 1;
`;
